export const clientConfig = {
    id: 'client',
    initial: 'draft',
    states: {
        draft: {
            on: { ACTIVATE: { target: 'active', guard: 'hasContactPerson' } },
        },
        active: {
            on: {
                DEACTIVATE: { target: 'deactivated' },
            },
        },
        deactivated: {
            on: {
                ACTIVATE: { target: 'active', guard: 'hasContactPerson' },
            },
        },
    },
};
//# sourceMappingURL=client.js.map